import { RecommendedCartProductsA } from './RecommendedCartProductsA';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface RecommendedCartProductsProps {
  classNames?: string;
  limit?: number;
}

export type RecommendedCartProductsVariants = 'A';

const RecommendedCartProductsController = (props: PropsWithCustomComponent<RecommendedCartProductsProps>) => (
  <VariantsController<RecommendedCartProductsProps, RecommendedCartProductsVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: RecommendedCartProductsA },
      name: 'RecommendedCartProducts',
    }}
  />
);
export { RecommendedCartProductsController as RecommendedCartProducts };
